/* SEEN – product page enhancements: hover thumbnails, swatch image preview, live % badge, review scroll. */
(function () {
  const parseMoney = (text) => {
    if (!text) return 0;
    const cleaned = text.replace(/[^0-9.,]/g, '').replace(/,(?=\d{3}(\D|$))/g, '').replace(',', '.');
    const value = parseFloat(cleaned.replace(/\.(?=.*\.)/g, ''));
    return isNaN(value) ? 0 : value;
  };

  function initSaveBadge(priceWrap) {
    const update = () => {
      const badge = priceWrap.querySelector('[data-seen-save]');
      if (!badge) return;
      const priceEl = priceWrap.querySelector('.price-regular .price');
      const compareEl = priceWrap.querySelector('.compare-price');
      const price = parseMoney(priceEl && priceEl.textContent);
      const compare = parseMoney(compareEl && compareEl.textContent);
      if (compare > price && price > 0) {
        const pct = Math.round(((compare - price) * 100) / compare);
        const label = (window.seenStrings && window.seenStrings.savePercent) || '[percent]% OFF';
        const text = label.replace('[percent]', pct);
        if (badge.textContent.trim() !== text) badge.textContent = text;
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    };
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; update(); });
    }).observe(priceWrap, { childList: true, subtree: true, characterData: true });
    update();
  }

  // ---------- Product gallery: thumbnail hover + swatch image preview (document-level, works in the editor too) ----------
  const isMouse = (event) => !event.pointerType || event.pointerType === 'mouse';
  const sectionOf = (el) => el.closest('[data-seen-product]') || el.closest('.shopify-section') || document;
  const galleryOf = (el) => sectionOf(el).querySelector('slide-with-thumbs');

  function previewLayer(gallery) {
    const host = gallery && (gallery.querySelector('.media-main-swiper') || gallery.querySelector('.swiper-wrapper-preview'));
    if (!host) return null;
    let layer = host.querySelector(':scope > .seen-swatch-preview');
    if (!layer) {
      layer = document.createElement('img');
      layer.className = 'seen-swatch-preview';
      layer.alt = '';
      layer.setAttribute('aria-hidden', 'true');
      host.appendChild(layer);
    }
    return layer;
  }

  function swatchImage(label) {
    const raw = label.getAttribute('data-image');
    if (!raw) return '';
    return raw.split('?')[0] + '?width=1200';
  }

  function initGalleryEvents() {
    if (document.documentElement.dataset.seenGallery) return;
    document.documentElement.dataset.seenGallery = 'true';

    document.addEventListener('pointerover', (event) => {
      if (!isMouse(event) || !event.target.closest) return;

      const thumb = event.target.closest('.thumbnail-slide .swiper-slide');
      if (thumb) {
        const gallery = thumb.closest('slide-with-thumbs');
        const swiper = gallery && gallery.globalSlide;
        const index = Array.prototype.indexOf.call(thumb.parentElement.children, thumb);
        if (swiper && index > -1 && swiper.activeIndex !== index) swiper.slideTo(index, 300);
        return;
      }

      const label = event.target.closest('label.product__color-swatch');
      if (label && !label.closest('.product-item')) {
        const src = swatchImage(label);
        const layer = src && previewLayer(galleryOf(label));
        if (!layer) return;
        if (layer.getAttribute('src') !== src) layer.setAttribute('src', src);
        requestAnimationFrame(() => layer.classList.add('is-visible'));
      }
    }, { passive: true });

    const hide = (el) => {
      const gallery = galleryOf(el);
      const layer = gallery && gallery.querySelector('.seen-swatch-preview');
      if (layer) layer.classList.remove('is-visible');
    };
    document.addEventListener('pointerout', (event) => {
      const label = event.target.closest && event.target.closest('label.product__color-swatch');
      if (!label || label.closest('.product-item')) return;
      // Keep the last previewed colour while the mouse crosses the gap between swatches;
      // hide only when the pointer leaves the whole swatch row.
      const group = label.parentElement;
      const to = event.relatedTarget;
      if (to && group && group.contains(to)) return;
      hide(label);
    }, { passive: true });
    document.addEventListener('pointerout', (event) => {
      // Leaving the swatch row from a gap (not from a swatch) also ends the preview
      const t = event.target;
      if (!t || !t.querySelector || t.closest('.product-item')) return;
      const hasSwatches = t.querySelector(':scope > label.product__color-swatch');
      if (!hasSwatches) return;
      const to = event.relatedTarget;
      if (to && t.contains(to)) return;
      hide(t);
    }, { passive: true });
    document.addEventListener('click', (event) => {
      const label = event.target.closest && event.target.closest('label.product__color-swatch');
      if (label && !label.closest('.product-item')) hide(label);
    });
  }

  function initReviewScroll(scope) {
    scope.querySelectorAll('.review_sold').forEach((el) => {
      el.addEventListener('click', (event) => {
        const target = document.getElementById('judgeme_product_reviews') || document.querySelector('.jdgm-review-widget, .jdgm-widget.jdgm-review-widget');
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function init() {
    initGalleryEvents();
    document.querySelectorAll('.product-detail__price').forEach(initSaveBadge);
    document.querySelectorAll('.product-detail, [data-seen-product]').forEach((scope) => {

      initReviewScroll(scope);
    });
    if (!document.querySelector('[data-seen-product]')) {

      initReviewScroll(document);
    }
  }

  if (document.readyState === 'complete') init();
  else window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();

// Size guide tabs: main (Product / Body) and sub (Tops / Bottoms); delegated so they work inside the popup copy
document.addEventListener('click', (event) => {
  const tab = event.target.closest && event.target.closest('.seen-size-tab, .seen-size-subtab');
  if (!tab) return;
  const nav = tab.parentElement;
  const wrap = nav && nav.parentElement;
  if (!wrap) return;
  const id = tab.getAttribute('data-seen-tab');
  nav.querySelectorAll('[data-seen-tab]').forEach((t) => t.classList.toggle('is-active', t === tab));
  wrap.querySelectorAll(':scope > [data-seen-panel]').forEach((p) => { p.hidden = p.getAttribute('data-seen-panel') !== id; });
});

// Keep the SKU in Additional Details in sync with the selected variant
(function () {
  const syncSku = () => {
    document.querySelectorAll('[data-seen-skus]').forEach((json) => {
      const scope = json.closest('[data-seen-product]') || json.closest('.shopify-section') || document;
      const input = scope.querySelector('form[action*="/cart/add"] input[name="id"]') || document.querySelector('form[action*="/cart/add"] input[name="id"]');
      const out = scope.querySelector('[data-seen-sku]');
      if (!input || !out) return;
      let map = {};
      try { map = JSON.parse(json.textContent); } catch (e) { return; }
      const sku = map[input.value];
      if (sku === undefined) return;
      out.textContent = sku;
      out.closest('.seen-specs__row').hidden = !sku;
    });
  };
  document.addEventListener('change', () => setTimeout(syncSku, 350));
})();

// Expose the header height so sticky panels (collection filters) sit just below it
(function () {
  const setHeaderHeight = () => {
    const header = document.querySelector('header.header');
    const h = header ? Math.round(header.getBoundingClientRect().height) : 70;
    document.documentElement.style.setProperty('--seen-header-h', `${h}px`);
  };
  setHeaderHeight();
  window.addEventListener('load', setHeaderHeight);
  window.addEventListener('resize', setHeaderHeight, { passive: true });
})();

// SEEN announcement bar: rotate messages one at a time + optional countdown
(function () {
  const pad = (n) => String(n).padStart(2, '0');
  function initBar(bar) {
    if (bar.dataset.ready) return;
    bar.dataset.ready = '1';
    const msgs = Array.from(bar.querySelectorAll('.seen-ann__msg'));
    // countdowns
    bar.querySelectorAll('.seen-ann__countdown').forEach((el) => {
      const end = new Date(el.dataset.end.replace(' ', 'T')).getTime();
      if (isNaN(end)) return;
      const tick = () => {
        const d = end - Date.now();
        if (d <= 0) { el.hidden = true; return; }
        const days = Math.floor(d / 864e5), h = Math.floor(d / 36e5) % 24, m = Math.floor(d / 6e4) % 60, s = Math.floor(d / 1e3) % 60;
        el.textContent = (days ? days + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
        el.hidden = false;
      };
      tick(); setInterval(tick, 1000);
    });
    if (msgs.length < 2) return;
    let i = 0, timer = null;
    const interval = Number(bar.dataset.interval) || 4000;
    const show = (next) => {
      const cur = msgs[i];
      i = (next + msgs.length) % msgs.length;
      if (cur === msgs[i]) return;
      cur.classList.remove('is-active'); cur.classList.add('is-leaving');
      setTimeout(() => cur.classList.remove('is-leaving'), 550);
      msgs[i].classList.add('is-active');
    };
    const start = () => { stop(); timer = setInterval(() => show(i + 1), interval); };
    const stop = () => { if (timer) clearInterval(timer); timer = null; };
    bar.querySelector('.seen-ann__arrow--next')?.addEventListener('click', () => { show(i + 1); start(); });
    bar.querySelector('.seen-ann__arrow--prev')?.addEventListener('click', () => { show(i - 1); start(); });
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    // theme editor: jump to selected block
    document.addEventListener('shopify:block:select', (e) => {
      const idx = msgs.findIndex((m) => m.contains(e.target) || m === e.target);
      if (idx > -1) { stop(); show(idx); }
    });
    start();
  }
  const run = () => document.querySelectorAll('.seen-ann').forEach(initBar);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();

// SEEN category showcase: arrows + progress bar
(function () {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const track = root.querySelector('.seen-cats__track');
    const prev = root.querySelector('.seen-cats__arrow[data-dir="-1"]');
    const next = root.querySelector('.seen-cats__arrow[data-dir="1"]');
    const bar = root.querySelector('.seen-cats__progress span');
    const progress = root.querySelector('.seen-cats__progress');
    if (!track) return;
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      const ratio = track.clientWidth / track.scrollWidth;
      if (progress) progress.style.display = max <= 2 ? 'none' : '';
      if (bar) {
        bar.style.width = (ratio * 100) + '%';
        bar.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * ((1 / ratio) - 1) * 100 : 0) + '%)';
      }
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    };
    const step = (dir) => {
      const item = track.querySelector('.seen-cats__item');
      const w = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth / 2;
      track.scrollBy({ left: dir * w * 2, behavior: 'smooth' });
    };
    prev && prev.addEventListener('click', () => step(-1));
    next && next.addEventListener('click', () => step(1));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }
  const run = () => document.querySelectorAll('[data-seen-cats]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();

// Card swatches: keep the picked colour image visible until the mouse leaves the card
(function () {
  document.addEventListener('click', (e) => {
    const sw = e.target.closest && e.target.closest('.product-item .product__color-swatches--js');
    if (!sw) return;
    const item = sw.closest('.product-item');
    if (!item) return;
    item.classList.add('seen-swatch-picked');
    if (!item.dataset.seenPickBound) {
      item.dataset.seenPickBound = '1';
      item.addEventListener('mouseleave', () => item.classList.remove('seen-swatch-picked'));
    }
  });
})();

/* Ask a question: success toast, reopen on error, and send the selected options with the message */
(() => {
  const run = () => {
    const success = document.querySelector('[data-ask-success]');
    if (success) {
      const toast = document.createElement('div');
      toast.className = 'seen-toast';
      toast.setAttribute('role', 'status');
      toast.textContent = success.textContent.trim();
      document.body.append(toast);
      requestAnimationFrame(() => toast.classList.add('is-visible'));
      setTimeout(() => toast.classList.remove('is-visible'), 6000);
      setTimeout(() => toast.remove(), 6600);
    }
    if (document.querySelector('[data-ask-error]')) {
      const trigger = document.querySelector('product-addons[data-custom-class="ask-question"]');
      if (trigger) setTimeout(() => trigger.click(), 300);
    }
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!form || form.id !== 'AskQuestionForm') return;
      const link = form.querySelector('input[name="contact[Product link]"]');
      if (link) link.value = window.location.href.split('#')[0];
      const variantField = form.querySelector('[data-ask-variant]');
      const cartForm = document.querySelector('form[action*="/cart/add"]');
      const scope = cartForm ? cartForm.closest('.shopify-section') || document : document;
      const picked = [...scope.querySelectorAll('input[type="radio"]:checked, select[name^="options"]')]
        .filter((el) => !el.closest('#AskQuestionForm'))
        .map((el) => el.value)
        .filter(Boolean);
      if (variantField && picked.length) variantField.value = [...new Set(picked)].join(' / ');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* Size guide IN / CM toggle: tables are entered in inches; CM is calculated (1 in = 2.54 cm) */
(() => {
  const STORE_KEY = 'seen-size-unit';
  const fmt = (n) => {
    const r = Math.round(n * 10) / 10;
    return Number.isInteger(r) ? String(r) : r.toFixed(1);
  };
  // One pass so a converted value is never converted again: mixed fractions (30 1/2), fractions (3/4), decimals and ranges (30-32).
  const toCm = (text) =>
    text.replace(/(\d+(?:\.\d+)?)\s+(\d+)\/(\d+)|(\d+)\/(\d+)|\d+(?:\.\d+)?/g, (match, whole, num, den, n2, d2) => {
      if (whole !== undefined) return fmt((parseFloat(whole) + num / den) * 2.54);
      if (n2 !== undefined) return fmt((n2 / d2) * 2.54);
      return fmt(parseFloat(match) * 2.54);
    });
  const headCm = (text) =>
    text.replace(/\binch(es)?\b/gi, 'cm').replace(/\(\s*in\s*\)/gi, '(cm)').replace(/["”″]/g, '');

  const apply = (wrap, unit) => {
    wrap.setAttribute('data-seen-units', unit);
    wrap.querySelectorAll('.seen-unit-toggle__btn').forEach((btn) => {
      const on = btn.getAttribute('data-seen-unit') === unit;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    wrap.querySelectorAll('.seen-size-table table').forEach((table) => {
      [...table.rows].forEach((row, rowIndex) => {
        [...row.cells].forEach((cell, cellIndex) => {
          const isHead = cell.tagName === 'TH' || rowIndex === 0;
          if (!isHead && cellIndex === 0) return; // size labels (XS, S, 28...) stay as they are
          if (cell.dataset.seenIn === undefined) cell.dataset.seenIn = cell.innerHTML;
          const original = cell.dataset.seenIn;
          if (unit === 'in') {
            cell.innerHTML = original;
            return;
          }
          const plain = cell.textContent;
          if (isHead) {
            const next = headCm(plain);
            if (next !== plain) cell.textContent = next;
          } else if (/\d/.test(plain)) {
            cell.textContent = toCm(plain.replace(/["”″]|\binch(es)?\b|\bin\b/gi, '').trim());
          }
        });
      });
    });
  };

  document.addEventListener('click', (event) => {
    const btn = event.target.closest && event.target.closest('.seen-unit-toggle__btn');
    if (!btn) return;
    const wrap = btn.closest('[data-seen-units]');
    if (!wrap) return;
    const unit = btn.getAttribute('data-seen-unit');
    apply(wrap, unit);
    try { localStorage.setItem(STORE_KEY, unit); } catch (e) { /* ignore */ }
  });

  // Remember the shopper's last choice the next time a size guide opens.
  const restore = () => {
    let unit = 'in';
    try { unit = localStorage.getItem(STORE_KEY) || 'in'; } catch (e) { /* ignore */ }
    if (unit !== 'cm') return;
    document.querySelectorAll('[data-seen-units="in"]').forEach((wrap) => apply(wrap, 'cm'));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restore); else restore();
})();

/* Product info accordions: only one open at a time (Description, Additional Details, other rows) */
document.addEventListener('click', (event) => {
  if (!event.target.closest) return;
  const heading = event.target.closest('.shopify-section[id*="__main"] collapsible-block > .collapsible-heading');
  const summary = event.target.closest('.shopify-section[id*="__main"] details.seen-specs > summary');
  if (!heading && !summary) return;
  const current = (heading || summary).parentElement;
  const section = current.closest('.shopify-section');
  // collapsible-block has already toggled itself; <details> toggles after this click finishes
  const opening = heading ? current.classList.contains('active') : !current.open;
  if (!opening || !section) return;
  section.querySelectorAll('collapsible-block.active').forEach((block) => {
    if (block === current) return;
    const head = block.querySelector(':scope > .collapsible-heading');
    if (head) head.click();
  });
  section.querySelectorAll('details.seen-specs[open]').forEach((details) => {
    if (details !== current) details.open = false;
  });
});
